import type { Mission } from '../missions.ts'

export const faa: Mission = {
  id: "faa",
  name: "Federal Aviation Administration",
  short: "FAA",
  call: "Aviation",
  kind: "subagency",
  parent: "dot",
  url: "https://www.faa.gov/",
  established: 1958,
  palette: {
    primary: "#15396c",
    secondary: "#0a6826",
    accent: "#b0862c",
  },
  colorSource: {
    kind: "site",
    url: "https://www.faa.gov/",
  },
  motif: "plane",
  mission: {
    text: "Our continuing mission is to provide the safest, most efficient aerospace system in the world.",
    url: "https://www.faa.gov/about/mission",
  },
  fact: {
    text: "Created as the independent Federal Aviation Agency in 1958, it was renamed the Federal Aviation Administration when DOT opened in 1967.",
    url: "https://www.faa.gov/about/history/brief_history",
  },
  seal: {
    file: "public/seals/faa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Aviation_Administration.svg",
  },
  identifier: {
    about: "https://www.faa.gov/about",
    accessibility: "https://www.faa.gov/accessibility",
    foia: "https://www.faa.gov/foia",
    noFear: "https://www.transportation.gov/civil-rights/civil-rights-awareness-enforcement/no-fear-act",
    oig: "https://www.oig.dot.gov/",
    performance: "https://www.faa.gov/about/plans_reports",
    privacy: "https://www.faa.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/faa-aeronautical-center.jpg",
        small: "/media/faa-aeronautical-center-sm.jpg",
        alt: "Vintage color aerial view of the FAA Aeronautical Center's hangars and ramp beside crossing runways, with farmland stretching to the horizon.",
        title: "Aerial view of the FAA Aeronautical Center ramp area, Oklahoma City, 1973",
        creator: "Federal Aviation Administration",
        source: "https://commons.wikimedia.org/wiki/File:FAA_Aeronautical_Center_73-1079P.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/faa-n1-jet.jpg",
        small: "/media/faa-n1-jet-sm.jpg",
        alt: "A white and blue FAA Gulfstream IV jet marked United States of America and N1, parked on a concrete ramp under a cloudy sky.",
        title: "FAA Gulfstream IV (N1) at Ellington Field, Houston, May 21, 2003",
        creator: "NASA Johnson Space Center",
        source: "https://images.nasa.gov/details/jsc2003e37449",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
